import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ProjectClass, projectClassFactory } from '@/types/projectClass';
import { RootState } from '@/store';
import i18n from '@/settings/i18n';

import { ProjectClasses } from '@/components/pages/Subscription/Presentation/Form/Field/ProjectClasses';

type Props = {
  selected?: number | null;
  error?: string;
  onChange: (projectClassId: number | null) => void;
};

const emptyProjectClass = projectClassFactory({
  name: i18n.t('ui.expression.notApplicable'),
});

const selector = (state: RootState) => ({
  projectClasses: [
    emptyProjectClass,
    ...state.organization.projectClass.bundled,
  ],
});

export const ProjectClassesContainer: React.FC<Props> = ({
  selected,
  error,
  onChange,
}) => {
  const { projectClasses } = useSelector(selector);
  const [selectedClass, setSelectedClass] = useState<ProjectClass>(() => {
    if (selected) {
      return (
        projectClasses.find((projectClass) => projectClass.id === selected) ||
        emptyProjectClass
      );
    }
    return emptyProjectClass;
  });
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) {
      onChange(selectedClass.id);
    } else {
      setInitialized(true);
    }
  }, [initialized, onChange, selectedClass]);

  if (projectClasses.length <= 1) {
    return null;
  }

  return (
    <ProjectClasses
      error={error}
      selectedClass={selectedClass}
      projectClasses={projectClasses}
      setSelectedClass={setSelectedClass}
    />
  );
};
